import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import classNames from 'classnames'
import { useSignerBrand } from './useSignerBrand'

const WorkspaceLogo = ({ fallback, alt = 'Assinafy logo', ...props }) => {
  const { signerAccessCode } = useParams()
  const brand = useSignerBrand(signerAccessCode)
  const [failedSrc, setFailedSrc] = useState(null)
  const customSrc = brand.logoSrc && failedSrc !== brand.logoSrc ? brand.logoSrc : null
  const { className } = props

  useEffect(() => {
    setFailedSrc(null)
  }, [brand.logoSrc])

  if (brand.status === 'loading') {
    return <span className={classNames('logo-pending', className)} aria-hidden="true" />
  }

  return (
    <img
      {...props}
      src={customSrc || fallback}
      alt={customSrc ? (brand.accountName || 'Logo') : alt}
      className={classNames(className, customSrc && 'is-workspace-logo')}
      onError={() => {
        if (customSrc) {
          setFailedSrc(customSrc)
        }
      }}
    />
  )
}

export default WorkspaceLogo
